module.exports = "//d274d294w9cx2v.cloudfront.net/de2fc4028e4a48bfd6e2dbe8e904ea134b1eb4cd/images/digital-invites.jpg";